import Vue from 'vue'
import Vuex from 'vuex'

import user from './module/user'
import trade from './module/trade'
import quant from './module/quant'
import other from './module/other'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //
  },
  mutations: {
    //
  },
  actions: {
    //
  },
  modules: {
    user,
    trade,
    quant,
    other,
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js